import React, { useState } from 'react';
import { useAsync } from 'react-async';
import { getMyProfile } from '../../api/services/meService';
import Layout from '../../components/layout';
import { useHistory } from 'react-router-dom';
import User from '../../api/models/user';
import UserResponse from '../../api/responses/userResponse';
import { Role } from '../../common/constants';
import { hasValue } from '../../common/utils';
import UserRole from '../../api/models/userrole';

const AdminDashboardPage = () => {
  const [user, setUser] = useState<User>();
  const history = useHistory();
  const asyncUser = useAsync({
    promiseFn: getMyProfile,
    onResolve: (response: UserResponse) => {
      const user: User = response.data.user;
      const adminRoles: UserRole[] = user.userRoles.filter((role: UserRole) => role.role.name === Role.Admin || role.role.name === Role.SuperUser);
      const isAdminRole: boolean = adminRoles.length > 0;

      if (hasValue(user.userRoles) && user.userRoles.length > 0 && !isAdminRole)
        history.push('/');
      else
        history.push('/messages');

      setUser(user);
    }
  });

  return (
    <Layout isLoading={asyncUser.isPending}>
      <React.Fragment>
        {asyncUser.error && (
          <React.Fragment>
            <h3>Something went wrong!</h3>
            <p>{asyncUser.error.message}</p>
          </React.Fragment>
        )}

        {hasValue(user) && (
          <div>
            Hello {user?.firstName}! Your admin user id is: {user?.userId}
          </div>
        )}
      </React.Fragment>
    </Layout>
  );
};

export default AdminDashboardPage;
